// packages/shared-hooks/src/clients/useCreateClient.ts
//
// `POST /clients` — atomically creates the client + its first primary
// contact. Invalidates every list slot (filter-prefix match) so the new
// row floats into view regardless of which filter is active.
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { ClientDetailSchema, type ClientDetail, type CreateClientInput } from '@magimp/shared';
import { useApiClient } from '../api/context.js';
import { clientsKeys } from './keys.js';

export function useCreateClient() {
  const client = useApiClient();
  const qc = useQueryClient();
  return useMutation<ClientDetail, unknown, CreateClientInput>({
    mutationFn: (input) => client.post<ClientDetail>('/clients', input, {}, ClientDetailSchema),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: clientsKeys.all });
    },
  });
}
